import cn from 'classnames';
import * as React from 'react';
import { block } from './utils';

interface Props
  extends Pick<
    React.HTMLProps<HTMLButtonElement | HTMLDivElement>,
    'onMouseOut' | 'onMouseOver'
  > {
  children?: React.ReactNode;
  position?: 'start' | 'end';
  onClick?: () => void;
  className?: string;
}

const InputAdornment = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    position = 'start',
    onClick,
    className,
    onMouseOut,
    onMouseOver,
  } = props;
  const classes = cn(block('adornment', { [position]: true }), className);

  if (onClick) {
    return (
      <button
        {...{ onClick, onMouseOut, onMouseOver }}
        type="button"
        className={classes}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={classes} {...{ onMouseOut, onMouseOver }} ref={ref}>
      {children}
    </div>
  );
});

export default InputAdornment;
